var map = {
	"./Auth.json": "1b00",
	"./Booking.json": "8231",
	"./BossUsers.json": "3122",
	"./Manage.json": "880c",
	"./Review.json": "f7c9",
	"./Settings.json": "0d1e",
	"./SideBar.json": "89bf",
	"./Users.json": "14e6",
	"./meta.json": "6572"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8a16";